import { MdDragIndicator } from 'react-icons/md';
import { useDragState } from './DragContext';

// Follows the pointer during a drag. Deliberately a small chip rather than a card-sized preview:
// cards are ~half a screen tall, so a full-size preview hid the very cards the user was aiming at.
export const DragOverlay = () => {
  const dragState = useDragState();
  if (!dragState) return null;

  return (
    <div
      className='dashboard-drag-overlay'
      style={{ left: dragState.pointerX, top: dragState.pointerY }}
    >
      <MdDragIndicator />
      <span className='drag-overlay-title'>{dragState.label}</span>
    </div>
  );
};
